module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAADcAgMAAABrDwB8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEUAV7f/1wD////m/UymAAAAAWJLR0QCZgt8ZAAAAAd0SU1FB+kJBBc2B3H8pO8AAABISURBVHja7cxBCQAACASwi+jH/lUsIQiyBVgCAAAAAAAAAAC80+vK6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l03p4De9zV8qClRqsAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjUtMDktMDRUMjM6NTQ6MDcrMDA6MDCs2Nq9AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDI1LTA5LTA0VDIzOjU0OjA3KzAwOjAw3YViAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/wkl.png
// module id = eOYB
// module chunks = 128